import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import "./SectionHeader.css";

/**
 * Reusable SectionHeader component with optional "View All" button
 * @param {string} title - The section title
 * @param {string} subtitle - Optional subtitle description
 * @param {string} viewAllPath - Optional path for "View All" button (only shows if provided)
 * @param {React.ReactNode} rightContent - Optional content to display on the right side (badges, etc.)
 * @param {string} className - Additional custom classes
 */
function SectionHeader({ title, subtitle, viewAllPath, rightContent, className = "" }) {
  const navigate = useNavigate();

  return (
    <div className={`section-header ${className}`}>
      <div className="section-header-content">
        <h2 className="section-header-title">{title}</h2>
        {subtitle && <p className="section-header-subtitle">{subtitle}</p>}
      </div>
      <div className="section-header-actions">
        {rightContent}
        {viewAllPath && (
          <button
            className="section-header-view-all"
            onClick={() => navigate(viewAllPath)}
          >
            View All
            <FiArrowRight size={16} />
          </button>
        )}
      </div>
    </div>
  );
}

export default SectionHeader;
